import React from "react"
import {FieldEditableMode, FieldEditableProps} from "../../../../proto/render/editable";
import {FieldViewSize} from "../../../../const";
import Votes from "../../../../../model2/voting/votes";
import FieldVoting_View from "../view";
import {ALL_REACTIONS} from "../../../../../model2/reaction/const";
import FieldVoting from "../../voting";
import ProjectSession from "../../../../../model2/project/project-session";
import EmojiSymbolDeprecated from "../../../../../gd-components/icons/common/emoji/emoji-symbol";

// const debug = "FieldVoting_Editable"
const debug = false

type State = {
    mode                : FieldEditableMode

    initialPropsValue   : any
    currentValue        : any
    showPopover         : boolean
}

export default class FieldVoting_Editable extends React.Component<FieldEditableProps,State> {

    public previousValue        : any

    public static defaultProps  = {
        size        : FieldViewSize.DEFAULT
    }

    constructor(props:FieldEditableProps) {
        super(props);

        const value = props.field.getViewValue(props.model)

        debug && console.log(debug,"constructor initValue=", value)

        this.state = {

            mode                : FieldEditableMode.VIEW,

            initialPropsValue   : value, // required to check if currentOption update needed on props changed
            currentValue        : value,
            showPopover         : false
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {

        // const newValue = props.model[props.field.fieldId]
        const newValue = props.field.getViewValue(props.model)

        debug && console.log(debug, "getDerivedStateFromProps newValue=", newValue)

        if (newValue !== state.initialPropsValue) {

            debug && console.log(debug, "props have changed - apply to state and set initialPropsValue")

            return {
                initialPropsValue   : newValue,
                currentValue        : newValue
            }
        }
        return null
    }

    get classes():string {

        // min-w-80 -needed in editable like project info

        return Classes("ui5-field-editable min-w-80", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
    }

    onClick = () => {

        if(this.state.showPopover){
            return false
        }

        const value = this.props.field.getViewValue(this.props.model)

        const votes : Votes = Votes.initFromJson(value)
        votes.toggleVote()

        this.onValueChange(votes.toJSON())
    }


    onValueChange = (value:any) => {

        debug && console.log(debug, "onValueChange", value)

        this.previousValue  = this.state.currentValue;
        const newValue      = value; //_.get(option, 'value', null);

        this.setState({
            currentValue: newValue
        }, () => {

            if (this.props.onChange) {
                // @ts-ignore
                this.props.onChange(newValue, this.onCancelChange);
            }

        });

        if(this.state.showPopover){
            this.hidePopover()
        }
    }

    onInfoClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        this.setState((prevState)=>{
            return {
                showPopover: !prevState.showPopover,
                mode       : FieldEditableMode.HOVERED
            }
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            mode            : FieldEditableMode.VIEW
        })
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        });
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (this.state.mode === FieldEditableMode.VIEW) this.setState({
            mode   : FieldEditableMode.HOVERED
        })
    }

    onMouseLeave = () => {
        if (this.state.mode === FieldEditableMode.HOVERED && !this.state.showPopover) {
            this.setState({
                mode        : FieldEditableMode.VIEW
            })
        }
    }

    get canEdit():boolean {

        const project : ProjectSession | null = gd.session.projects.get(this.props.model.projectId)

        if (!project) return false

        if (project.acl.hasClientAccess) return true

        return false
    }

    renderView() {
        return (
            <div className={this.classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                {/*{this.renderValue()}*/}
                <FieldVoting_View field={this.props.field} model={this.props.model} />
            </div>
        )
    }

    renderHovered() {

        const field         = this.props.field as unknown as FieldVoting
        const currentValue  = this.props.field.getViewValue(this.props.model)

        const votes : Votes = Votes.initFromJson(currentValue)
        const isEmpty       = votes.isEmpty

        const classes       = Classes(this.classes, "is-hovered")

        return (
            <div className={classes} style={this.props.style} onClick={this.onClick} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>

                {!isEmpty &&
                    <FieldVoting_View field={this.props.field} model={this.props.model} />
                }

                {isEmpty &&
                    <div className="flex-row-left-center">
                        <EmojiSymbolDeprecated symbol={ALL_REACTIONS[field.voteIcon]} className="ui5-black-and-white m-r-8" size="14" />
                        <div className="ui5-txt-no-accent-small">0</div>
                    </div>
                }

                {this.state.showPopover &&
                    <field.components.PopoverMenu {...this.props} parent={this} />
                }

                <div className="buttons flex-no-shrink">
                    {!isEmpty &&
                        <div className="btn-info ii5-information" onClick={this.onInfoClick}/>
                    }

                </div>
            </div>
        )
    }

    render() {

        debug && console.log(debug, "render() size=",this.props.size, this.state)
        debug && console.log(debug, "render() isHovered=", this.state.mode)

        switch (this.state.mode) {

            case FieldEditableMode.HOVERED:
                return this.renderHovered()

            default:
            case FieldEditableMode.VIEW:
                return this.renderView()
        }
    }
}
